import defaultConfig from '.';

export default {
  ...defaultConfig,
  loadGDPRScript: true,
};
